var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 6H5.33331C3.12431 6 1.33331 7.791 1.33331 10C1.33331 12.209 3.12431 14 5.33331 14H10.6666C12.8756 14 14.6666 12.209 14.6666 10C14.6666 7.791 12.8756 6 10.6666 6Z",
    stroke: "#22AED1",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8.66668V11.3333M4 10H6.66667M8 5.33334V3.23801H10.6667V1.33334",
    stroke: "#22AED1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 11.3334C11.0203 11.3334 11.3594 11.1929 11.6095 10.9428C11.8595 10.6928 12 10.3536 12 10C12 9.6464 11.8595 9.30726 11.6095 9.05721C11.3594 8.80716 11.0203 8.66669 10.6666 8.66669C10.313 8.66669 9.97389 8.80716 9.72384 9.05721C9.47379 9.30726 9.33331 9.6464 9.33331 10C9.33331 10.3536 9.47379 10.6928 9.72384 10.9428C9.97389 11.1929 10.313 11.3334 10.6666 11.3334Z",
    stroke: "#22AED1",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaming);
export default __webpack_public_path__ + "static/media/gaming.2c52ff5bc0139806f41c1cbe4bcdea5c.svg";
export { ForwardRef as ReactComponent };